import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { Accordion as ZinniaAccordion } from '@zapier/design-system';
import { useTracking } from '../../tracking';
import { RichText } from '../RichText';
import { captureBuilderIOKitException } from '../../init';
import { useRendererContext } from '../../content-renderers/RendererContext';
export function Accordion(props) {
    const { setStructuredData } = useRendererContext();
    const { emitUserInteractionEvent } = useTracking();
    useEffect(() => {
        if (!props.includeInFAQStructuredData || !setStructuredData)
            return;
        setStructuredData((prevState) => {
            try {
                const structuredData = prevState ? JSON.parse(prevState) : [];
                if (!Array.isArray(structuredData))
                    return prevState;
                let schemaIndex = structuredData === null || structuredData === void 0 ? void 0 : structuredData.findIndex((schema) => schema['@type'] === 'FAQPage');
                if (schemaIndex === -1) {
                    structuredData.push({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [],
                    });
                    schemaIndex = structuredData.length - 1;
                }
                const questionIndex = structuredData[schemaIndex].mainEntity.findIndex((question) => question.name === props.title);
                const question = {
                    '@type': 'Question',
                    name: props.title,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: props.content,
                    },
                };
                if (questionIndex === -1) {
                    structuredData[schemaIndex].mainEntity.push(question);
                }
                else {
                    structuredData[schemaIndex].mainEntity[questionIndex] = question;
                }
                return JSON.stringify(structuredData);
            }
            catch (e) {
                captureBuilderIOKitException(new Error('Error parsing structured data in Accordion with title ' +
                    props.title));
                return '[]';
            }
        });
    }, [
        setStructuredData,
        props.includeInFAQStructuredData,
        props.title,
        props.content,
    ]);
    const handleToggle = ({ isOpen }) => {
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'toggle',
            interaction_raw_text: props.title,
            option_selected: isOpen ? 'opening' : 'closing',
        });
    };
    return (_jsx(ZinniaAccordion, Object.assign({ title: props.title, href: props.href, isInitiallyOpen: props.isInitiallyOpen, isOpen: props.isOpen, onToggle: handleToggle, toggleSide: props.toggleSide }, { children: _jsx(RichText, { html: props.content }) })));
}
//# sourceMappingURL=Accordion.js.map